import { install } from '@github/hotkey';
import tippy from 'tippy.js';

class Component {
  onMount() {
    setTimeout(() => {
      tippy('[data-tippy-factory]', {
        arrow: true,
        maxWidth: 'none',
        appendTo: () => document.body,
      });
    }, 1);

    setTimeout(this.mountHotkeys.bind(this), 1);
  }

  mountHotkeys() {
    for (const el of document.querySelectorAll('[data-hotkey]')) {
      install(el);
    }
  }

  onBurgerClick(event, element) {
    event.preventDefault();

    element.classList.toggle('is-active');
    document
      .getElementById(element.dataset.target)
      .classList.toggle('is-active');
  }
}

export default Component;
